let url = "https://drive-strike.herokuapp.com";
// let url = "http://localhost:5002";
let shareurl = "https://sharehere-strike.herokuapp.com"

module.exports = {url,shareurl};
